var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHips3Male(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 112,
    viewBox: "0 0 100 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1628_9743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.838 34.7865C20.838 34.7865 30.5292 39.2751 50.0602 39.4806C67.3183 39.6634 77.2494 35.3575 77.2494 35.3575C77.2494 35.3575 79.7588 44.7258 80.7337 50.5758C81.3749 54.4226 81.7087 64.2256 81.7087 64.2256V78.8504C81.7087 78.8504 75.5704 81.4255 65.2909 81.1686C55.0115 80.9116 49.5341 76.9004 49.5341 76.9004L49.7461 70.8151L47.2733 70.3811V76.9004C47.2733 76.9004 43.3443 80.9116 29.764 79.8951C16.1837 78.8786 14.4346 75.9254 14.4346 75.9254V69.2666L15.4096 61.3006L16.3845 56.4257L18.3345 45.7008L20.8494 34.7808L20.838 34.7865Z",
    fill: "#909091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2448 -30.4375C18.479 -28.6729 17.5081 -24.0872 17.9536 -21.112C18.5989 -16.7433 19.17 -12.9172 19.8553 -9.30801C21.7456 0.582881 21.8198 0.474378 22.7735 7.57275C23.5559 13.3919 23.3731 16.3044 22.5851 19.628C21.7913 22.9459 21.0488 26.0468 20.7747 31.5576C20.7062 32.8996 20.7405 34.0075 20.7747 34.7327C17.9536 46.5995 13.9774 62.4003 14.4343 80.8001C14.4343 90.5 14.2253 102 19 111.5",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 113C47.5836 104.5 47.8758 100.355 47.5836 92.5003C47.2674 84 46.5707 76.5635 47.2674 70.3788C47.6043 70.533 48.0326 70.6815 48.5352 70.7614C49.9857 70.9899 51.1678 70.5159 51.7103 70.2532",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4836 112C50.5087 99.3252 51.4836 110.05 50.5087 99.3252C49.5337 92.5003 49.9972 73.4713 49.5518 70.8215",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5 110.5C81.7085 99 81.6115 91.8814 81.7085 85C81.8228 77.1935 82.2796 83.2937 81.7085 64.2257C81.5886 60.1483 80.3789 49.4708 78.9912 41.967C78.46 39.0945 77.889 36.736 77.4664 35.1142C77.552 33.1782 77.5806 30.2087 77.2151 26.611C76.5698 20.3521 75.1078 18.2962 74.394 13.5392C73.5716 8.05698 75.1992 7.41737 76.7125 -1.69115C78.2887 -11.2051 78.3972 -12.5129 77.9803 -18.1893C77.889 -19.3942 78.4201 -22.1297 78.2031 -25.8016C78.0317 -28.7198 78.4829 -32.7172 78.0603 -34.6189",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0716 -71.3638C58.5348 -67.372 58.7347 -64.1226 59.0545 -62.1639C59.2087 -61.2102 59.6199 -60.3079 60.2652 -59.5884C61.533 -58.1778 63.2177 -57.2812 65.1651 -56.6816C65.245 -56.6588 65.3193 -56.6302 65.3935 -56.596L73.5771 -52.9982C73.6342 -52.9754 73.697 -52.9468 73.7541 -52.9297C79.5278 -50.9767 81.3438 -51.108 83.8451 -49.7888C89.2133 -46.9563 91.9031 -36.7799 91.9031 -29.9899C91.9031 -28.6251 91.8117 -28.6536 90.0414 -18.0603C89.082 -12.304 88.1282 -6.57617 87.757 -3.9721C86.2779 6.43275 87.4601 14.0394 87.9455 20.2012C88.6308 28.83 88.5052 41.5705 84.519 58.6512C84.9473 63.3054 84.1649 67.063 84.3306 69.6899C84.519 72.7337 84.5647 72.4467 84.3306 73.0006C82.8743 76.4499 83.2329 76.6706 81.7081 77.8755",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6847 -71.3638C38.2215 -67.372 38.0217 -64.1226 37.7018 -62.1639C37.5477 -61.2102 37.1365 -60.3079 36.4912 -59.5884C35.2234 -58.1778 33.5387 -57.2812 31.5913 -56.6816C31.5113 -56.6588 31.4371 -56.6302 31.3628 -56.596L23.1793 -52.9982C23.1221 -52.9754 23.0593 -52.9468 23.0022 -52.9297C17.4913 -51.068 14.2989 -50.2742 12.9112 -49.7888C7.28036 -47.8187 5.66991 -37.5509 5.27587 -35.0439C4.99033 -33.2222 4.80187 -30.8979 6.71499 -18.0603C8.02276 -9.28303 8.49676 -7.79825 8.99931 -3.9721C10.3585 6.31854 9.33625 13.7367 8.91365 18.9334C8.21122 27.6079 8.31402 40.5655 12.2316 58.6512C11.8033 63.3054 12.3972 63.5483 12.2316 66.1752C12.0432 69.219 11.6226 69.6247 13.4593 73.9751C14.9156 77.4244 12.9095 74.7201 14.4343 75.9251",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7581 16.8427C49.6033 15.9918 50.9738 15.9919 51.8305 16.837",
    stroke: "black",
    strokeWidth: 0.292862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 96C25 100.932 26.1176 107.228 30 111",
    stroke: "black",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 100C73 107.212 72.5833 108.485 68 114",
    stroke: "black",
    strokeWidth: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85979 67C-0.368968 83.1847 -1.1592 92.2852 4.85979 108.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0551 108.891C96.6149 92.2488 95.5168 83.1473 87.9037 67.5186",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1628_9743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 112,
    fill: "white",
    transform: "translate(7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHips3Male);
export default __webpack_public_path__ + "static/media/hips-3-male.f39c9ea4f01a0747042255fec90f783e.svg";
export { ForwardRef as ReactComponent };